import Vue from 'vue'
import Vuetify from 'vuetify'

/* Custom icons */
import HeartIcon from '@/components/icons/HeartIcon.vue'
import CartIcon from '@/components/icons/CartIcon.vue'
import ProfileIcon from '@/components/icons/ProfileIcon.vue'
import CopyIcon from '@/components/icons/CopyIcon.vue'
import NotificationIcon from '@/components/icons/NotificationIcon.vue'
import LanguageIcon from '@/components/icons/LanguageIcon.vue'
import PolicyIcon from '@/components/icons/PolicyIcon.vue'
import TncIcon from '@/components/icons/TncIcon.vue'
import HeartFullIcon from '@/components/icons/HeartFullIcon.vue'
import EnlargeIcon from '@/components/icons/EnlargeIcon.vue'

Vue.use(Vuetify)

const opts = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        'dark-green': '#109A50',
        'light-green': '#74CE00',
        'dark-grey': '#646464',
        'light-grey': '#a7a7a7',

        primary: {
          base: '#00c201',
          lighten1: '#74CE00',
          darken1: '#0c9a52',
          darken2: '#055436'
        },
        secondary: '#646464',
        orange: { base: '#FF9300', lighten1: '#FF914D' },
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        background: '#F6F6F6',
        facebook: '#3B5998'
      }
    }
  },
  icons: {
    values: {
      heart: { component: HeartIcon },
      cart: { component: CartIcon },
      profile: { component: ProfileIcon },
      copy: { component: CopyIcon },
      notification: { component: NotificationIcon },
      language: { component: LanguageIcon },
      policy: { component: PolicyIcon },
      tnc: { component: TncIcon },
      heart_full: { component: HeartFullIcon },
      enlarge: { component: EnlargeIcon }
    }
  }
}

export default new Vuetify(opts)
